import styled from '@emotion/styled';
import {
  Button,
  Input,
  Modal,
  notification,
  Select,
  Space,
  Tag,
  Tooltip,
} from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { generate } from 'short-uuid';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { BondBidAskType, BondEntity } from '../../../../entities/bond.entity';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';
import { createFavoris, createOperation } from '../../network';
import { ConfirmationOrder } from './components/ConfirmOrder';
import { FractionOrder } from './components/FractionOrder';

const Container = styled.div`
  font-family: Poppins-R;
  zoom: 0.95;
  height: 100%;

  table,
  th,
  td {
    // font-weight: bold;
    border-bottom: 2px solid #666;
    border-top: 2px solid #666;
    padding-left: 5px;
  }

  td {
    margin: 2px;
  }

  td div {
    padding: 5px.;
  }

  .anticon {
    color: white;
  }

  .colortrans td {
    // background-color: rgba(255, 255, 255, 0.5);
  }

  td
    .ant-select-single.ant-select-sm:not(.ant-select-customize-input)
    .ant-select-selector {
    padding: 0 7px;
    background-color: transparent;
    color: white;
    border: none;
  }

  td .coloriage {
    background-color: ${YELLOW};
    color: #fff;
    width: 100%;
    padding-left: 2px;
  }

  td .coloriage2 {
    padding-left: 2px;
    background-color: #ccc;
    color: #111;
    width: 100%;
  }

  td .coloriage1 {
    background-color: ${ORANGE};
    color: #fff;
    width: 100%;
  }

  .qteInput {
    width: 100px;
    height: 25px;
    background-color: transparent;
    color: #fff;
    border: none;
  }

  > .top {
    background-color: ${PRIMARY};
    padding: 5px;
    font-family: Poppins-R;
    border-radius: 5px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  > .content {
    padding: 0px 5px 0px 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 80%;
    zoom: 0.85;

    > div {
      flex: 1;
    }
  }
`;

export const getYieldToMaturity = (
  settlementDate: Date,
  maturityDate: Date,
  issueDate: Date,
  rate: number,
  faceValue: number,
  price: number,
) => {
  // Convertir les dates en objets Date
  settlementDate = new Date(settlementDate);
  maturityDate = new Date(maturityDate);
  issueDate = new Date(issueDate);

  // Calculer le nombre de jours entre la date d'émission et la date d'échéance
  const N =
    (maturityDate.getTime() - issueDate.getTime()) / (1000 * 60 * 24 * 365);

  // Calculer le nombre de jours entre la date d'émission et la date de règlement
  const A =
    (settlementDate.getTime() - issueDate.getTime()) / (1000 * 60 * 24 * 365);
  // Calculer le rendement à l'échéance
  const yieldToMaturity =
    ((faceValue - price) / price) * (365 / (N - A)) +
    (rate * faceValue) / price;

  return yieldToMaturity;
};

const getNextCouponDate = (
  dateTransaction: Date,
  maturityDate: Date,
  frequency: number,
) => {
  let nextDate = new Date(maturityDate);

  while (nextDate.getTime() > dateTransaction.getTime()) {
    nextDate.setMonth(nextDate.getMonth() - 12 / frequency);
  }
  nextDate.setMonth(nextDate.getMonth() + 12 / frequency);
  return nextDate;
};

export const OrderEntry = ({
  selectedBond,
  selectedOpe,
  detenteurVendeur,
  bondBidAsk,
  updateProfondeur,
}: {
  selectedBond?: BondEntity;
  selectedOpe: string;
  detenteurVendeur?: string;
  bondBidAsk: BondBidAskType;
  updateProfondeur: () => void;
}) => {
  const datejour = new Date();
  const valeurNominale = 10000;
  const [clicked, setClicked] = useState('0');
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [operation, setOperation] = useState({
    qte: 0,
    prix: 0,
  });
  const [lmtOptions, setLmtOptions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDetenteur, setSelectedDetenteur] = useState('');
  const [param, setParam] = useState<any>({
    com_intermediation: 0,
    com_conservation: 0,
    droit_garde: 0,
    com_courtage: 0,
    mnt_global: 0,
    decote: 0,
    valaPay: 0,
    valaPercevoir: 0,
    com1: 0,
    com2: 0,
    com3: 0,
    com4: 0,
    montant: 0,
    prix: 0,
  });

  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [favorisClick, setFavorisClick] = useState(false);
  interface PriceItem {
    value: number;
    label: string;
  }

  useEffect(() => {
    if (selectedBond) {
      let prices: PriceItem[] = [];
      let percent = 0.85;
      let val = 0;
      while (percent <= 1.16) {
        val = Math.floor(selectedBond.valeurNominale * percent);
        prices.push({
          value: val,
          label: `${Math.floor(percent * 100)}% - ${formatNum(val)} XAF`,
        });
        percent += 0.01;
      }

      setLmtOptions(prices);
    }
  }, [selectedBond]);

  useEffect(() => {
    setClicked(selectedOpe);
  }, [selectedOpe]);

  const annulerOrdre = () => {
    setOperation({ qte: 0, prix: 0 });
    setShowModal(false);
  };

  const sendOffer = () => {
    setIsLoading(true);
    var qte = operation.qte;
    var prix = operation.prix;
    var rendement = 0;
    if (param) {
      qte = param.qte;
      prix = 10000;
      rendement = getYieldToMaturity(
        datejour,
        dateMature,
        dateEmission,
        selectedBond?.tauxMarginal ?? 0,
        valeurNominale,
        prix,
      );
    }
    console.log(param, qte, prix);
    let operationToCreate = {
      code: generate(),
      typeOperation: clicked === '1' ? 'ACHAT' : 'VENTE',
      dateOperation: `${new Date().getFullYear()}-${
        new Date().getMonth() + 1
      }-${new Date().getDate()}`,
      qteOriginal: qte,
      qteRestant: qte,
      prixNominale: prix,
      montantOriginal: qte * valeurNominale,
      montantRestant: qte * valeurNominale,
      decote: decote,
      tauxInteret: selectedBond?.tauxMarginal,
      tauxRendement: rendement.toFixed(2),
      frequence: selectedBond?.frequencePaiement,
      couponCouruPayer: Number(valaPay),
      couponPercevoir: Number(valaPercevoir),
      commIntermediation:
        clicked === '1' ? Math.round((prix * qte * 0.27) / 100) : 0,
      commConservation:
        clicked === '1' ? Math.round((prix * qte * 0.2) / 100) : 0,
      commDroitGarde:
        clicked === '1' ? Math.round((prix * qte * 0.3) / 100) : 0,
      commBrokerage: clicked === '1' ? Math.round((prix * qte * 0.2) / 100) : 0,
      statut: 'En attente',
      bond: selectedBond?.url,
      utilisateur: connectedUser.url,
      detenteur: selectedDetenteur || detenteurVendeur,
    };
    console.log(operationToCreate);

    createOperation(operationToCreate).then(({ statusCode, data }) => {
      console.log(data);
      if (statusCode.toString()[0] === '2') {
        notification.success({
          message: 'Offre transmis',
          description: 'Votre ordre a été transmis avec succès ',
        });
        // afficher le statuts des matchs
        notification.info({
          message: "Statut de l'ordre",
          description: data.match.message,
        });
        updateProfondeur();
      } else {
        notification.error({
          message: 'Erreur',
          description: data.message,
        });
      }
      setIsLoading(false);
      setShowModal(false);
      setShowModal1(false);
      // history.go(0);
    });
  };

  const addFavoris = () => {
    let objToPost = {
      bond: selectedBond?.url,
      utilisateur: connectedUser.url,
    };
    createFavoris(objToPost).then((resp) => {
      console.log(resp);
      setFavorisClick(true);
    });
  };

  useEffect(() => {
    // reset click on favoris back to default
    setFavorisClick(false);
  }, [selectedBond]);

  var decote = 100 - operation.prix / 100;
  var prixT =
    clicked === '1' ? operation.prix / 100 + 0.97 : operation.prix / 100;
  var prixCom = (operation.prix * operation.qte * 0.97) / 100;
  var valaPay = '0';
  var valaPercevoir = '0';
  var dateCoupn = new Date();
  var rendement = 0;
  if (selectedBond?.dateMaturite) {
    var dateMature = new Date(selectedBond?.dateMaturite);
    var dateEmission = new Date(selectedBond?.dateEmission);
    var duree_annee =
      (dateMature.getTime() - datejour.getTime()) / (1000 * 60 * 24 * 365);
    //recupérons les chiffres après la virgule
    var valString = duree_annee.toString();
    var nbre = valString.split('.');
    var delta = parseFloat('0.' + nbre[1]);
    const prixTaux =
      (operation.qte * valeurNominale * selectedBond?.tauxMarginal) / 100;
    const valaRestant = prixTaux * delta;
    valaPercevoir = valaRestant.toFixed(2);
    var valaPayer = prixTaux - parseFloat(valaPercevoir);
    valaPay = valaPayer.toFixed(2);
    dateCoupn = getNextCouponDate(datejour, dateMature, 1);
    rendement = getYieldToMaturity(
      datejour,
      dateMature,
      dateEmission,
      selectedBond?.tauxMarginal,
      valeurNominale,
      operation.prix,
    );
  }

  return (
    <Container>
      <div className='top' style={{ padding: 10, marginBottom: 5 }}>
        <Space>
          <div style={{ color: 'orange' }}>Saisie d'ordres</div>

          {selectedBond && (
            <Space>
              <Tag
                style={{
                  backgroundColor:
                    clicked === '1'
                      ? '#81c784' // green
                      : '#ef5350', // red
                  fontSize: '13',
                  color: clicked === '1' ? '#111' : '#111',
                  marginLeft: 20,
                }}
              >
                {clicked === '1' ? 'Achat' : clicked === '2' ? 'Vente' : ''}
              </Tag>
              <Tooltip title='Ajouter aux favoris'>
                <FaStar
                  size={16}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                  color={favorisClick ? YELLOW : undefined}
                  onClick={addFavoris}
                />
              </Tooltip>
            </Space>
          )}
        </Space>

        <Button
          className='butt'
          disabled={selectedBond ? false : true}
          style={{ borderRadius: 20, height: 25 }}
          onClick={() => setShowModal1(true)}
        >
          <div style={{ marginTop: -2, fontSize: 13 }}>
            Acheter une Fraction
          </div>
        </Button>

        <Button
          className='butt'
          disabled={selectedBond ? false : true}
          style={{ borderRadius: 20, height: 25 }}
          onClick={() => setShowModal(true)}
        >
          <div style={{ marginTop: -2, fontSize: 13 }}>Soumettre</div>
        </Button>
      </div>

      <div className='content'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <table style={{ width: '100%' }}>
            <tbody>
              <tr className='colortrans'>
                <td>
                  <div>Code</div>
                </td>
                <td>
                  <div className='coloriage'>{selectedBond?.code || '--'}</div>
                </td>
                <td>
                  <div>Pays</div>
                </td>
                <td>
                  <div className='coloriage'>{selectedBond?.pays || '--'}</div>
                </td>
                <td>
                  <div>Type obligation</div>
                </td>
                <td>
                  <div className='coloriage'>
                    {selectedBond?.instrument || '--'}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Date Valeur </div>
                </td>
                <td>
                  <div className='coloriage'>
                    {moment(new Date()).format('DD/MM/YYYY')}
                  </div>
                </td>
                <td>
                  <div>Prix d'achat</div>
                </td>
                <td>
                  <div className='coloriage1'>
                    <Select
                      size='small'
                      value={operation.prix}
                      style={{ width: '100%', minWidth: 130 }}
                      options={lmtOptions}
                      onChange={(val) =>
                        setOperation({ ...operation, prix: Number(val) })
                      }
                    />
                  </div>
                </td>
                <td>
                  <div>Quantité </div>
                </td>
                <td>
                  <div className='coloriage1'>
                    <Input
                      className='qteInput'
                      placeholder='qte'
                      value={operation.qte}
                      type='number'
                      min={0}
                      onChange={(e) =>
                        setOperation({
                          ...operation,
                          qte: Number(e.target.value),
                        })
                      }
                    />
                  </div>
                </td>
              </tr>
              <tr className='colortrans'>
                <td>
                  <div>Maturité </div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {moment(selectedBond?.dateMaturite).format('DD/MM/YYYY') ||
                      '--'}
                  </div>
                </td>
                <td>
                  <div>Décote</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {formatNum(parseFloat(decote.toFixed(2)))}%
                  </div>
                </td>
                <td>
                  <div>Valeur nominale </div>
                </td>
                <td>
                  <div className='coloriage2'>{formatNum(valeurNominale)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Date d'émission </div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {moment(selectedBond?.dateEmission).format('DD/MM/YYYY') ||
                      '--'}
                  </div>
                </td>
                <td>
                  <div>Total Commission</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {clicked === '1' ? 0.97 : 0}%
                  </div>
                </td>
                <td>
                  <div>Montant global </div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {formatNum(operation.qte * valeurNominale)}
                  </div>
                </td>
              </tr>
              <tr className='colortrans'>
                <td>
                  <div>Taux intéret cible </div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {selectedBond?.tauxMarginal || '--'}
                  </div>
                </td>
                <td>
                  <div>Prix total</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {formatNum(parseFloat(prixT.toFixed(2)))}%
                  </div>
                </td>
                <td>
                  <div>Coupon couru à payer</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {formatNum(parseInt(valaPay))} XAF
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Date prochain coupon </div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {moment(dateCoupn).format('DD/MM/YYYY')}
                  </div>
                </td>
                <td>
                  <div>Fréquence coupon</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {selectedBond?.frequencePaiement || '--'}
                  </div>
                </td>
                <td>
                  <div>Total des Commissions</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {clicked === '1'
                      ? formatNum(parseFloat(prixCom.toFixed(2)))
                      : 0}
                  </div>
                </td>
              </tr>
              <tr className='colortrans'>
                <td>
                  <div>Taux de rendement </div>
                </td>
                <td>
                  <div className='coloriage'>
                    {formatNum(parseFloat(rendement.toFixed(2)))}
                  </div>
                </td>
                <td>
                  <div>
                    {clicked === '1' ? 'Total à payer' : 'Total à percevoir'}
                  </div>
                </td>
                <td>
                  <div className='coloriage'>
                    {clicked === '1'
                      ? formatNum(
                          Math.round(
                            clicked === '1'
                              ? operation.prix * operation.qte +
                                  operation.prix * operation.qte * 0.0097 +
                                  parseFloat(valaPay)
                              : operation.prix * operation.qte +
                                  parseFloat(valaPay),
                          ),
                        )
                      : formatNum(
                          Math.round(
                            operation.prix * operation.qte -
                              operation.prix * operation.qte * 0.0097 +
                              parseFloat(valaPay),
                          ),
                        )}{' '}
                  </div>
                </td>
                <td>
                  <div>Coupon à percevoir</div>
                </td>
                <td>
                  <div className='coloriage2'>
                    {formatNum(parseInt(valaPercevoir))} XAF
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ margin: 5 }}></div>
      </div>

      <Modal
        className='dark-modal'
        open={showModal}
        title="Confirmation de l'ordre"
        onCancel={() => setShowModal(false)}
        width={800}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              danger
              onClick={() => setShowModal(false)}
              style={{ border: '2px solid red', borderRadius: 20 }}
            >
              Fermer
            </Button>
            <Button
              danger
              onClick={annulerOrdre}
              style={{ border: '2px solid red', borderRadius: 20 }}
            >
              Annuler l'ordre
            </Button>
            <Button
              className='butt'
              loading={isLoading}
              style={{ borderRadius: 20 }}
              onClick={sendOffer}
              disabled={clicked === '2' ? false : !selectedDetenteur}
            >
              Transmettre l'ordre
            </Button>
          </div>,
        ]}
      >
        <ConfirmationOrder
          bond={selectedBond as BondEntity}
          typeOpe={clicked === '1' ? 'achat' : 'vente'}
          detailOpe={operation}
          getSelectedDetenteur={setSelectedDetenteur}
        />
      </Modal>
      <Modal
        className='dark-modal'
        open={showModal1}
        title='Acheter une fraction'
        onCancel={() => setShowModal1(false)}
        width={800}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              danger
              onClick={() => setShowModal1(false)}
              style={{ border: '2px solid red', borderRadius: 20 }}
            >
              Fermer
            </Button>
            <Button
              className='butt'
              loading={isLoading}
              style={{ borderRadius: 20 }}
              onClick={sendOffer}
              disabled={clicked === '2' ? false : !selectedDetenteur}
            >
              Transmettre l'ordre
            </Button>
          </div>,
        ]}
      >
        <FractionOrder
          bond={selectedBond as BondEntity}
          typeOpe={clicked === '1' ? 'achat' : 'vente'}
          detailOpe={operation}
          getSelectedDetenteur={setSelectedDetenteur}
          getParam={setParam}
        />
      </Modal>
    </Container>
  );
};
function setLocalDetailOpe(arg0: any) {
  throw new Error('Function not implemented.');
}
